import axios from 'axios';
import { API_URL } from '../config';

let axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

axiosInstance.interceptors.response.use(null, (error) => {
  if (error && error.response) {
    if (error.response.status === 401) {
      // initial call to whoami will get intercepted here and redirect, need to throw log event
      // TODO: Do something
      if (!error.config || error.config.url !== '/auth/login') {
        window.location.href = '/logout';
      }
    }
    const { data } = error.response;
    const errorPayload =
      data.error || data.errors || data.error_message || data.error_type;

    return Promise.reject(errorPayload);
  }

  return Promise.reject(error);
});

export default axiosInstance;
